import { Button, Result } from "antd";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

export default function Forbidden() {
	const history = useHistory();
	// Initial time in seconds (10s)
	const initialTime = 10;
	const [timeRemaining, setTimeRemaining] = useState(initialTime);

	useEffect(() => {
		const timerInterval = setInterval(() => {
			setTimeRemaining((prevTime) => {
				if (prevTime === 1) {
					clearInterval(timerInterval);
					// Perform actions when the timer reaches zero
					console.log("Countdown complete!");
					history.replace("/dashboard");
					return 0;
				} else {
					return prevTime - 1;
				}
			});
		}, 1000);

		// Cleanup the interval when the component unmounts
		return () => clearInterval(timerInterval);
	}, []);

	const seconds = timeRemaining % 60;

	return (
		<Result
			status="403"
			title="403"
			subTitle="Sorry, you are not authorized to access this page."
			extra={
				<Button
					type="primary"
					onClick={() => history.replace("/dashboard")}
				>
					Back to Dashboard ({seconds}s)
				</Button>
			}
		/>
	);
}
